<template>
	<div class="suggested-post-modal-content">
		<section class="suggested-post-modal-image-container">
			<span role="heading" class="suggested-post-modal-heading"
				>Suggested Media</span
			>
			<div class="suggested-post-modal-image">
				<img id="item-container" :src="[image]" />
			</div>
		</section>
		<section class="suggested-post-modal-text-container">
			<span role="heading" class="suggested-post-modal-heading"
				>Suggested Content
				<FormLabelTooltip
					:tooltip="`You have the option of including additional text above your post. Write your own, or use our suggested text. Click Copy to Clipboard, Next, Compose Post, and paste into the Content box.`"
				/>
			</span>

			<textarea
				class="suggested-post-modal-text js-suggested-text"
				@input="
					clicked = false;
					buttonText = 'Copy to Clipboard';
				"
				>{{ content }}</textarea
			>
			<div class="suggested-post-modal-button-wrapper">
				<button
					class="b360-btn"
					:class="[clicked ? 'b360-btn--success' : 'b360-modal-action-btn']"
					@click="
						copyText();
						clicked = true;
						buttonText = 'Copied';
					"
				>
					{{ buttonText }}
				</button>
			</div>
		</section>
	</div>
</template>

<script>
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';

export default {
	name: 'SuggestedPostModalContent',
	components: {
		FormLabelTooltip,
	},
	methods: {
		copyText() {
			this.$el.querySelector('.js-suggested-text').select();
			document.execCommand('Copy');
		},
	},
	props: {
		image: String,
		content: String,
	},
	data() {
		return {
			buttonText: 'Copy to Clipboard',
			clicked: false,
		};
	},
};
</script>

<style lang="scss" scoped>
.composer-post-wrapper {
	position: relative;

	nav.social-composer-nav {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
	}
}

.suggested-post-modal {
	&-content {
		@include rem('padding', 20px 20px 20px);
		position: relative;
		top: 40px; /* this accounts for the Compose Nav menu height tablet and above resolutions */
		height: calc(100vh - 280px);
		@include rem(min-height, 640px);
		@include mobile {
			height: calc(100vh - 341px);
		}
		@media only screen and (max-width: 620px) {
			top: 59px; /* this accounts for the Compose Nav menu height tablet to iPhone 375px resolutions */
		}
		@media only screen and (max-width: 375px) {
			top: 78px; /* this accounts for the Compose Nav menu height iPhone 375px and below resolutions */
			height: calc(100vh - 360px);
		}
		left: 0;
		border: 0;
		min-height: 100%;
		overflow-y: auto;

		&::-webkit-scrollbar {
			@media (pointer: fine) {
				@include rem(width, 10px);

				&-thumb {
					background: $brand-teal;
				}
			}
		}
	}

	&-image-container {
		@include rem('margin-bottom', 20px);
	}

	&-heading {
		display: inline-block;
		@include rem('margin-bottom', 12px);
	}

	&-image {
		line-height: 0;
		border-radius: $b360-border-radius-base;
		overflow: hidden;
		max-width: 65%;
		margin: 0 auto;

		img {
			width: 100%;
			height: auto;
		}
	}

	&-text {
		box-sizing: border-box;
		border: $b360-border-width-thin solid $border-color-light;
		border-radius: $b360-border-radius-base;
		background-color: $white;
		width: 100%;
		max-width: 100%;
		font-size: $b360-font-size--base;
		resize: none;
		outline: none;
		@include typo--roboto__regular;
		@include rem('padding', 12px);
		@include rem('margin-bottom', 20px);
		@include rem('line-height', 24px);
	}

	&-button-wrapper {
		display: flex;
		justify-content: flex-end;
	}
}

.suggested-post-modal-heading {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
